import React from 'react'

import {useRecaptcha} from '@helios/shared/hooks/use-recaptcha'
import createHubspotContact from '@helios/shared/utils/create-hubspot-contact'

type CreateHubspotContactParams = Parameters<typeof createHubspotContact>
type HubspotState = CreateHubspotContactParams[1]
type HubspotProperties = CreateHubspotContactParams[2]

/**
 * This hook handles the common flow of executing reCAPTCHA, calling the Hubspot
 * API (with the reCAPTCHA token), and managing the loading state
 */
export const useRecaptchaHubspotSubmit = () => {
    const [loading, setLoading] = React.useState(false)
    const captcha = useRecaptcha('hubspot_create_contact')

    const recaptchaHubspotSubmit = async (
        hubspotState: HubspotState,
        hubspotProperties: HubspotProperties,
        onError?: () => void,
        onSuccess?: () => void
    ) => {
        try {
            setLoading(true)

            await captcha?.protectedCall(
                async (captchaToken) =>
                    await createHubspotContact(captchaToken, hubspotState, hubspotProperties)
            )
            onSuccess && onSuccess()
        } catch (error) {
            console.error(error)
            onError && onError()
        } finally {
            setLoading(false)
        }
    }

    return {recaptchaHubspotSubmit, loading}
}
